// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"114":"buyer","182":"transfers","665":"voucher"}[chunkId] || chunkId) + "-legacy." + {"114":"5a0a4d55","182":"a6e153a4","263":"5f34346b","665":"cd9728a1","702":"84c3966f","790":"17e29064","947":"0ee4674e"}[chunkId] + ".js";
};